var map = {
	"./401.svg": "96ec",
	"./404.svg": "8a81",
	"./4g.jpg": "967d",
	"./avatar.png": "1195",
	"./carte_CIB.jpg": "b3a0",
	"./cloud (1).png": "9850",
	"./cloud (2).png": "5318",
	"./cloud.png": "0e0a",
	"./database.svg": "c97c",
	"./distrisam.jpeg": "1c4d",
	"./djezzy.svg": "93ac",
	"./djezzy_logo.png": "98c6",
	"./dome.png": "0c92",
	"./green_number.png": "ad5c",
	"./iPhone.png": "e2f7",
	"./idoom.svg": "e415",
	"./idoom_logo.png": "edf6",
	"./jumia.png": "32d8",
	"./jumia3.svg": "3f53",
	"./logo-Récupéré.png": "e2a5",
	"./logo-header.png": "c5b4",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo2.png": "5fbe",
	"./logo_gifty.svg": "0d26",
	"./logo_gifty_white.svg": "286c",
	"./lte.svg": "b5c1",
	"./mobilis.svg": "b727",
	"./mobilis_logo.png": "6a03",
	"./money_icon.svg": "c9ae",
	"./no-image.png": "bd21",
	"./no-transaction.svg": "8e47",
	"./nomadis.svg": "cb76",
	"./ooredoo.svg": "28ae",
	"./ooredoo_logo.png": "d71c",
	"./opus.png": "573b",
	"./opus2.png": "8876",
	"./opuspromo.svg": "9cde",
	"./phone.png": "3547",
	"./refill.png": "a472",
	"./s1.svg": "22f4",
	"./s2.svg": "011d",
	"./s3.svg": "d802",
	"./s4.svg": "f593",
	"./salepoint.png": "32b0",
	"./snax.png": "f56b",
	"./success-lottie": "077d",
	"./success-lottie.json": "077d",
	"./temtem.png": "e86a",
	"./unilever.svg": "06d9",
	"./voucher.png": "dd3b",
	"./yassir.png": "bd09",
	"./yassir.svg": "6507"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";